import type { Event, EventCallable, Store } from 'effector'

import { sample } from 'effector'

export function postpone<T>({
  clock,
  until,
  target,
}: {
  clock: Event<T>
  until: Store<boolean>
  target: EventCallable<T>
}): EventCallable<T> {
  sample({
    clock: [clock, until],
    source: clock,
    filter: until,
    target,
  })
  return target
}
